export default __webpack_public_path__ + "static/media/world.76d00190.svg";